import { HttpStatus } from '@/modules/core/app/constants/api.constants';
import { AxiosRequestConfig } from '@/modules/core/app/models/AxiosRequestConfig';

export class ApiError extends Error {
  /**
   * @var {string}
   */
  message;

  /**
   * @var {AxiosRequestConfig}
   */
  config;

  /**
   * @var {number}
   */
  status;

  /**
   * @var {string}
   */
  file;

  /**
   * @var {array}
   */
  warnings;

  /**
   * @var {array|object}
   */
  errors;

  /**
   * @param response
   */
  constructor(response = {}) {
    super();

    this.message = response.data?.message ?? response.data?.error;
    this.status = response.status;
    this.config = response.config;
    this.file = response.file;
    this.warnings = response.warnings;
    this.errors = response.data?.errors;
  }

  /**
   * @returns {boolean}
   */
  get isStatusForbidden() {
    return this.status === HttpStatus.FORBIDDEN;
  }

  getSentryExtra() {
    return {
      ...this
    };
  }
}
